import React from 'react';
import { Link } from '@reach/router';
import { Card, CardCol, CardRow, C } from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';

export const ServiceCard = ({ service, path, components, ...props }) => (
  <Card {...props} to={path} components={{ Link, ...(components || {}) }}>
    <CardRow>
      <CardCol type={['prepend', 'icon']} className="my-2">
        <span
          className={`${service.values['Icon'] ||
            C.ICON_SERVICE} fa-md text-muted`}
        />
      </CardCol>
      <CardCol>
        <CardRow className="text-muted">
          <small>
            <I18n>SERVICE</I18n>
          </small>
        </CardRow>
        <CardRow type="title" className="">
          {service.values['Name']}
        </CardRow>
        <CardRow className="text-muted">
          {service.values['Short Description']}
        </CardRow>
      </CardCol>
    </CardRow>
  </Card>
);
